import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Breadcrumbs,
  BreadcrumbItem,
  Chip,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css
import { jwtDecode } from "jwt-decode"
import { useDispatch, useSelector } from "react-redux"
import { setTokenExpiry } from "../state/authSlice"
import { isMobile } from "react-device-detect"

export default function MainContainer({
  children,
  info = [],
  pageName = "",
  breadcrumbs = [],
  prevPage = {},
}) {
  const [expiryTime, setExpiryTime] = useState(null);

  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch();

  useEffect(() => {

    if (token && token != "") {

      const decoded = jwtDecode(token);

      // Extract the expiration time and convert it to a human-readable format
      const expirationTime = new Date(decoded.exp * 1000); // Convert from seconds to milliseconds

      let hours = expirationTime.getHours();
      const minutes = expirationTime.getMinutes();
      const seconds = expirationTime.getSeconds();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      // Convert 24-hour format to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 becomes 12 (for midnight)

      // Format minutes and seconds to always show two digits
      const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} `;

      setExpiryTime(formattedTime + " " + ampm); // Show in a readable format

      dispatch(setTokenExpiry(expirationTime.getTime() / 1000))
    }
  }, []);

  return (
    <Card radius="none" shadow="sm" className={`${isMobile?"top-10":""} "rounded-none min-h-screen lg:px-20 z-1"`}>
      {/* lg:ml-64 */}
      <ToastContainer />
      <CardHeader className="flex p-1 w-full flex-col gap-1 
      bg-gradient-to-br from-white to-lfime-50 border-0 border-wi-200
       items-start sticky align-top">
        <div className="flex items-center justify-between w-full ">
         
          <div className="flex items-center justify-start ">
                 
            {/* breadcrumbs */}
            {breadcrumbs?.length > 0 && (
              <Breadcrumbs color="danger" variant="light" className="text-sm">
                 
                {breadcrumbs?.map((item) => {
                  return (
                    <BreadcrumbItem className="text-xs text-white" key={item}>
                      {item}
                    </BreadcrumbItem>
                  )
                })}
              </Breadcrumbs>
            )}
            {/* end of breadcrumbs */}

          </div>
          <div className=" text-xs font-semibold bg-h-100 text-rose-400">
            {"session expire at :" + expiryTime}
          </div>
        </div>
        <div className="w-full">
          {/* page heading */}
          <div className="flex items-center justify-between w-full pb-1 border-b-4   border-amber-200 ">
           <div color="primary" radius="sm"  className="w-full text-emerald-700 
           
            border-l-4 border-amber-200 uppercase
            
              font-semibold ml-5" ><div className="ml-3 text-sm" >{pageName} </div> </div>
            {prevPage && prevPage?.show && (
              <Chip
                size="md"
                color="success"
                variant="shadow"
                className=" p-2 cursor-pointer bg-gradient-to-t from-emerald-800 to-emerald-400 text-white"
                radius="sm"
                startContent={<FontAwesomeIcon icon={faChevronLeft} />}
                onClick={prevPage?.onClick}
              >
                Back
              </Chip>
            )}
          </div>
          <div className=" flex  flex-wrap text-custom-bg-light text-xs font-semibold">
            {info.map((infoItem, index) => {
              return (
                <div>
                  <FontAwesomeIcon  icon={faArrowAltCircleRight}></FontAwesomeIcon>
                <Chip key={index}  variant="light"
                color="danger" className="text-xs">
                  {infoItem.map((item, index) => 
                    //return (
                      
                        item +" "
                     
                   // )

                 )}
                </Chip>
                </div>
              )
            })}
          </div>
          {/* end of page heading */}
        </div>
      </CardHeader>
      <CardBody>{children}</CardBody>
      <CardFooter></CardFooter>
    </Card>
  )
}
